// src/services/supabaseClient.js
// ─────────────────────────────────────────────────────────────
// Replace the two placeholder values below with your actual
// Supabase project URL and anon/public key.
//
//   1. Go to https://app.supabase.com → your project → Settings → API
//   2. Copy "Project URL"  →  paste as SUPABASE_URL
//   3. Copy "anon public"  →  paste as SUPABASE_ANON_KEY
//
// Or use a .env file (recommended for production):
//   REACT_APP_SUPABASE_URL=https://xxxx.supabase.co
//   REACT_APP_SUPABASE_ANON_KEY=eyJhbGciOiJ...
// ─────────────────────────────────────────────────────────────

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL';

const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// ─────────────────────────────────────────────────────────────
// Required Supabase table (run in SQL editor):
//
// create table bookings (
//   id uuid primary key default gen_random_uuid(),
//   name text not null,
//   phone text not null,
//   address text not null,
//   num_pots integer not null,
//   preferred_date date not null,
//   status text default 'Pending',
//   created_at timestamptz default now()
// );
//
// Enable Row Level Security, then add policy:
// create policy "Allow all" on bookings for all using (true);
// ─────────────────────────────────────────────────────────────
